// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "root-3sGgs";
var _4 = "content-BQqrF";
var _5 = "title-Wch-Q";
var _6 = "message-BTmRS";
var _7 = "emojy-1mjnl";
var _8 = "checkbox__label-ke8Ur";
var _9 = "button-2r1z3";
var _a = "footer_wrapper-1JwhO";
var _b = "checkboxes_wrapper-2zVnI";
var _c = "footer-2K4FW";
export { _1 as "__esModule", _2 as "mobile", _3 as "root", _4 as "content", _5 as "title", _6 as "message", _7 as "emojy", _8 as "checkbox__label", _9 as "button", _a as "footer_wrapper", _b as "checkboxes_wrapper", _c as "footer" }
export default { "__esModule": _1, "mobile": _2, "root": _3, "content": _4, "title": _5, "message": _6, "emojy": _7, "checkbox__label": _8, "button": _9, "footer_wrapper": _a, "checkboxes_wrapper": _b, "footer": _c }
